export default __webpack_public_path__ + "static/media/error-icon.bba94908.svg";